import { connect } from 'react-redux';
import Viewer from './Viewer.js';
import OHIF from 'ohif-core';
import { redux } from '../api';

const { setTimepoints, setMeasurements } = OHIF.redux.actions;
const { setViewportSpecificData } = OHIF.redux.actions;
const { setAiProductHeatmapData, setApplicationInfo } = redux.actions;
const { setAiHeatmapDataSource, setAiHeatmapData, setUserInfo } = redux.actions;

const mapStateToProps = state => {
  return {
    viewports: state.viewports.viewportSpecificData,
    activeViewportIndex: state.viewports.activeViewportIndex,
    showCharts: !!'AI',
    aiProductDetailInfo: state.api.current.aiProductDetailInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTimepointsUpdated: timepoints => dispatch(setTimepoints(timepoints)),
    onMeasurementsUpdated: measurements =>
      dispatch(setMeasurements(measurements)),
    setViewportSpecificData: (viewportIndex, data) =>
      dispatch(setViewportSpecificData(viewportIndex, data)),
    setHeatmapDataSource: data => dispatch(setAiHeatmapDataSource(data)),
    setHeatmapData: data => dispatch(setAiHeatmapData(data)),
    onUserInfoUpdated: user => dispatch(setUserInfo(user)),
    setAiProductHeatmapData: data => dispatch(setAiProductHeatmapData(data)),
    setApplicationData: data => dispatch(setApplicationInfo(data)),
  };
};

const ConnectedViewer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Viewer);

export default ConnectedViewer;
